module.exports = __webpack_public_path__ + "static/media/www.jokko.app.36f6015c.svg";